"use client";

/**
 * CompletedToolsSummary - normal mode's single "Used N tools" line.
 *
 * Finished tool steps are collapsed so the answer leads; expanding shows each
 * step's result line. Running and failed tools are never collapsed.
 */

import { useState } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { colors } from "@/ui/tokens";
import type { AggregatedToolCall } from "@/lib/sola/types/tools";
import { ToolThinkingDisplay } from "./ToolThinkingDisplay";
import styles from "./CompletedToolsSummary.module.css";

export function CompletedToolsSummary({ toolCalls }: { toolCalls: AggregatedToolCall[] }) {
  const [expanded, setExpanded] = useState(false);
  const Chevron = expanded ? ExpandLessIcon : ExpandMoreIcon;

  return (
    <div>
      <button type="button" className={styles.toggle} onClick={() => setExpanded((e) => !e)} aria-expanded={expanded}>
        <CheckCircleOutlineIcon sx={{ fontSize: 16, color: colors.signal.success }} />
        Used {toolCalls.length} tools
        <Chevron sx={{ fontSize: 16 }} />
      </button>
      {expanded && (
        <div className={styles.list}>
          {toolCalls.map((toolCall) => (
            <ToolThinkingDisplay key={toolCall.toolCallId} toolCall={toolCall} />
          ))}
        </div>
      )}
    </div>
  );
}
